export default {
	"messageTemplate": {
		"templateCode": "模板编码",
		"templateName": "模板名称",
		"messageType": "消息类型",
		"templateContent": "模板内容信息",
		"version": "版本",
		"tabpanleName": "模板信息",
		"sms": "短信",
		"emailTitle": "邮件标题",
		"wechatMsg": "微信企业群消息",
		"dd": "钉钉",
		"message": "消息",
		"delelteWarning": "确定要删除该模板吗"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/messageTemplate/messageTemplate.js